import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { ArticleCard } from "@/components/ArticleCard";

export default function Listing({ type, types, title, tagline }) {
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    setArticles(null);
    const load = async () => {
      const list = types || [type];
      const results = await Promise.all(list.map((t) => api.get(`/articles?type=${t}`).then((r) => r.data).catch(() => [])));
      setArticles(results.flat());
    };
    load();
  }, [type, types]);

  return (
    <div>
      <Seo title={title} description={tagline} />
      <section className="border-b-2 border-stone-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14">
          <p className="font-mono-pm text-xs tracking-[0.25em] uppercase text-[#991B1B] mb-4">The PM Test</p>
          <h1 className="font-serif-display text-4xl sm:text-5xl font-black tracking-tight text-stone-900">{title}</h1>
          <p className="text-lg text-stone-600 mt-4 max-w-2xl">{tagline}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-8 py-14">
        {articles === null ? (
          <p className="font-mono-pm text-sm text-stone-500">Loading…</p>
        ) : articles.length === 0 ? (
          <div className="border-2 border-dashed border-stone-300 bg-white p-12 text-center">
            <p className="font-serif-display text-2xl text-stone-900">Nothing published here yet.</p>
            <p className="font-mono-pm text-sm text-stone-500 mt-3 max-w-lg mx-auto">
              We publish reviews only after a real, hands-on editorial evaluation is complete. Check back soon.
            </p>
          </div>
        ) : (
          <div data-testid="listing-grid" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((a) => <ArticleCard key={a.slug} article={a} />)}
          </div>
        )}
      </section>
    </div>
  );
}
